module.exports = __webpack_public_path__ + "files/5026dc8fdec21a4710dcaedaf246fafb.jpg";